const updateSelects = (state, action) => {
  if (state === undefined) {
    return {
      branches: [],
      branch: null,
      groups: [],
      group: null,
      group_id: null,
      discountGroup: [],
      scheduleGroup: [],
      scheduleGroupLoading: false,
      trainers: [],
      trainer: null,
      type_groups: [],
      state_training_children: [],
      photos: null,
      branchesLoading: false,
      trainersLoading: false,
      groupsLoading: false,
      error: null,
    };
  }

  switch (action.type) {
    case "BRANCHES_LOADING":
      return {
        ...state.selects,
        branchesLoading: true,
      };
    case "BRANCH_REQUEST":
      return {
        ...state.selects,
        branch: action.payload,
      };
    case "BRANCHES_LOADED":
      return {
        ...state.selects,
        error: null,
        branches: action.payload,
        branchesLoading: false,
      };
    case "BRANCHES_ERROR":
      return {
        ...state.selects,
        branches: [],
        branchesLoading: false,
        error: action.payload,
      };
    case "UPDATE_BRANCH":
      return {
        ...state.selects,
        error: null,
        branch: action.payload,
      };
    case "GROUPS_REQUEST":
      return {
        ...state.selects,
        groups: action.payload,
      };
    case "GROUP_REQUEST":
      return {
        ...state.selects,
        group: action.payload,
      };
    case "GROUP_DISCOUNT_LOADED":
      return {
        ...state.selects,
        discountGroup: action.payload,
      };
    case "GROUP_ID":
      return {
        ...state.selects,
        group_id: action.payload,
      };
    case "GROUPS_LOADING":
      return {
        ...state.selects,
        groupsLoading: true,
      };
    case "GROUPS_LOADED":
      return {
        ...state.selects,
        error: null,
        groups: action.payload,
        groupsLoading: false,
      };
    case "GROUPS_ERROR":
      return {
        ...state.selects,
        groups: [],
        groupsLoading: false,
        error: action.payload,
      };
    case "SCHEDULE_GROUP":
      return {
        ...state.selects,
        scheduleGroup: action.payload,
        scheduleGroupLoading: false,
      };
    case "SCHEDULE_GROUP_REQUEST":
      return {
        ...state.selects,
        scheduleGroupLoading: true,
      };
    case "SCHEDULE_GROUP_LOADING":
      return {
        ...state.selects,
        scheduleGroupLoading: action.payload,
      };
    case "UPDATE_GROUP":
      return {
        ...state.selects,
        groups: action.payload,
      };
    case "TRAINERS_REQUEST":
      return {
        ...state.selects,
        trainers: action.payload,
        trainersLoading: false,
        error: null,
      };
    case "TRAINERS_LOADING":
      return {
        ...state.selects,
        trainersLoading: true,
      };
    case "TRAINER_REQUEST":
      return {
        ...state.selects,
        trainer: action.payload,
      };
    case "TRAINERS_ERROR":
      return {
        ...state.selects,
        trainers: [],
        trainersLoading: false,
        error: action.payload,
      };
    case "UPDATE_TRAINER":
      const updatedTrainer = state.selects.trainers.map((item) => {
        if (item.id === action.payload.id) return action.payload;
        return item;
      });
      return {
        ...state.selects,
        trainer: updatedTrainer,
      };
    case "TYPE_GROUPS_REQUESTED":
      return {
        ...state.selects,
        type_groups: action.payload,
      };
    case "STATUS_TRAINING_CHILDREN":
      return {
        ...state.selects,
        state_training_children: action.payload,
      };
    case "GET_PHOTO":
      return {
        ...state.selects,
        photos: action.payload,
      };
    case "UNMOUNT_PHOTO":
      return {
        ...state.selects,
        photos: action.payload,
      };
    default:
      return state.selects;
  }
};

export default updateSelects;
